import { useTranslation } from "react-i18next";
import React from "react";
import { deleteEmailTemplate } from "../../../../../../axios/api/services";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/emailTemplatesControl";
import { SEARCH_FILTERS_GROUP } from "../../../../../../config/search/filters/groupsConfig";
import { useFormContext } from "react-hook-form";
import { onDeleteTableEntrySuccess } from "../../../../../../utils/functions";

const DeleteEmailTemplateDialog = ({ filterFn, records, total }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { getValues, setValue } = useFormContext();
  const group = SEARCH_FILTERS_GROUP.EMAIL_TEMPLATES;

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.emailTemplatesControl.modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "delete" }));
  };

  const onSuccess = () => {
    onDeleteTableEntrySuccess(group, records.length, total, filterFn, dispatch, closeModal, getValues, setValue, t);
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => deleteEmailTemplate(id)}
      onSuccess={onSuccess}
      title={"t.email.template.delete.dialog"}
      message={"m.delete.email.template.warning.message"}
    />
  );
};

export default DeleteEmailTemplateDialog;
